export default __webpack_public_path__ + "static/media/Logo.1addb026.JPG";